export default __webpack_public_path__ + "static/media/BeeCh5.6dc17c27.svg";